import React, { useState } from "react";
import { Div, Image, Anchor, Text } from "atomize";
import { useLocomotiveScroll } from "react-locomotive-scroll";
import { Link } from "gatsby"

import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import MobileHeaderMenu from "../common/MobileHeaderMenu";
import { OutboundLink } from "gatsby-plugin-google-gtag"


export default function Header() {
  const { scroll } = useLocomotiveScroll();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const navLinks = [
    {
      text: "Full-Preview",
      internalUrl: "/preview",
    },
    {
      text: "Examples",
      onClick: () => {
        scroll.scrollTo(document.querySelector("#examples"), { offset: -100 });
      },
    },
    {
      text: "Pricing",
      onClick: () => {
        scroll.scrollTo(document.querySelector("#pricing"));
      },
    },
    {
      text: "Try Demo",
      url: "https://gumroad.com/l/3dmade-demo",
    },
  ];

  scroll?.on("scroll", (instance) => {
    if (instance.scroll.y > 100 && !isScrolled) {
      setIsScrolled(true);
    } else if (instance.scroll.y < 100 && isScrolled) {
      setIsScrolled(false);
    }
  });

  return (
    <>
      <Div
        tag="header"
        className={isScrolled || mobileMenuOpen ? "scrolled" : ""}
        pos="relative"
        zIndex="2"
      >
        <WebsiteContainer>
          <CustomContainer>
            <Div
              pos="relative"
              d="flex"
              justify="space-between"
              align="center"
              minH="72px"
              transition
            >
              <Div
                d="flex"
                justify="flex-start"
                align="center"
                onClick={() => {
                  scroll.scrollTo(document.querySelector("section#hero"));
                }}
              >
                <Image
                  src="/images/icons/logo.svg"
                  alt="logo"
                  h="36px"
                  w="auto"
                />
              </Div>
              <Div
                d={{ lg: "none", xl: "block" }}
                pos="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                justify="center"
              >
                <Div
                  rounded="40px"
                  bg="rgba(0, 0, 0, 0.72)"
                  d="flex"
                  p="12px 20px"
                  border="1px solid"
                  borderColor="borderLight"
                >
                  {navIcons.map((link, index) => {
                    return (
                      <Image
                        key={`nav-${link.altText}`}
                        m={{
                          r: index === navIcons.length - 1 ? "0" : "0.5rem",
                        }}
                        h={{ xs: "28px", md: "32px" }}
                        w="auto"
                        src={link.icon}
                        alt={link.altText}
                      />
                    );
                  })}
                </Div>
              </Div>

              <Div d={{ xs: "none", lg: "flex" }} justify="flex-end">
                {navLinks.map((link, index) => {
                  const isLast = (index === navLinks.length - 1);

                  if (link.url) {
                    return (
                      <OutboundLink className="trans-opacity" href={link.url} target="_blank" style={{ whiteSpace: "nowrap" }}>
                        <Text
                          key={`navlink-${index}`}
                          m={{ r: { xs: "", lg: isLast ? "0" : "2.5rem" } }}
                          hoverTextColor={isLast ? "mint" : "white"}
                          textColor={index === 3 ? "mint" : "white"}
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {link.text}
                        </Text>
                      </OutboundLink>
                    )
                  }

                  if (link.internalUrl) {
                    return (
                      <Link to={link.internalUrl}>
                        <Text
                          key={`navlink-${index}`}
                          m={{ r: { xs: "", lg: isLast ? "0" : "2.5rem" } }}
                          hoverTextColor={isLast ? "mint" : "white"}
                          textColor={index === 3 ? "mint" : "white"}
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {link.text}
                        </Text>
                      </Link>
                    )
                  }

                  return (
                    <Anchor
                      className="trans-opacity"
                      onClick={link.onClick}
                      key={`navlink-${index}`}
                      m={{ r: { xs: "", lg: isLast ? "0" : "2.5rem" } }}
                      hoverTextColor={isLast ? "mint" : "white"}
                      textColor={index === 3 ? "mint" : "white"}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {link.text}
                    </Anchor>
                  );
                })}
              </Div>
              {/* Mobile Menu*/}
              <Div
                flexGrow="1"
                d={{ xs: "flex", lg: "none" }}
                justify="flex-end"
              >
                {mobileMenuOpen ? (
                  <Div onClick={() => setMobileMenuOpen(false)}> Close</Div>
                ) : (
                  <Image
                    src="/images/icons/menu.svg"
                    h="10px"
                    w="auto"
                    onClick={() => setMobileMenuOpen(true)}
                    alt="menu-dropdown-icon"
                  />
                )}
              </Div>
            </Div>
          </CustomContainer>
          <MobileHeaderMenu
            navLinks={navLinks}
            mobileMenuOpen={mobileMenuOpen}
            setMobileMenuOpen={setMobileMenuOpen}
          />
        </WebsiteContainer>
      </Div>
    </>
  );
}

const navIcons = [
  {
    icon: "/images/icons/png.svg",
    altText: "png-icon",
  },
  {
    icon: "/images/icons/figma.svg",
    altText: "figma-icon",
  },
  {
    icon: "/images/icons/cinema-4d.svg",
    altText: "cinema4D-icon",
  },
];
